import { render, staticRenderFns } from "./CheckSanisId.vue?vue&type=template&id=8510a97e&scoped=true"
import script from "./CheckSanisId.vue?vue&type=script&lang=js"
export * from "./CheckSanisId.vue?vue&type=script&lang=js"
import style0 from "./CheckSanisId.vue?vue&type=style&index=0&id=8510a97e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8510a97e",
  null
  
)

export default component.exports